<mp-list-header
  class="mp-list-header--spaced"
  headerPlaceholder="Export Historie"
  [totalItemsQuantity]="numberOfAllItems"
>
  <mat-icon class="content-header-icon" list-header-prefix svgIcon="export_icon" />
</mp-list-header>
